import { Divider, Stack } from "@mantine/core"
import {
  useGetApiWebCalendarGetProfilesSuspense,
  WebCalendarProfileDto,
} from "@/orval/gen"
import { CalendarProfileStackItem } from "./calendar-profile-stack-item"
import { useTranslation } from "react-i18next"

interface Props {
  onEditProfileClick: (profile: WebCalendarProfileDto) => void
}

export function CalendarStack({ onEditProfileClick }: Props) {
  const { t } = useTranslation("app_server")
  const { data: profiles } = useGetApiWebCalendarGetProfilesSuspense()

  return (
    <Stack>
      {profiles.personalProfiles.length ? (
        <>
          <Divider label={t("OwnCalendars")} labelPosition="left" />
          {profiles.personalProfiles.map((profile, i) => (
            <React.Fragment key={profile.webCalendarProfileId}>
              {i > 0 && <Divider />}
              <CalendarProfileStackItem
                onEditProfileClick={onEditProfileClick}
                profile={profile}
              />
            </React.Fragment>
          ))}
        </>
      ) : null}
      {profiles.sharedProfiles.length ? (
        <>
          <Divider label={t("SharedCalendars")} labelPosition="left" />
          {profiles.sharedProfiles.map((profile, i) => (
            <React.Fragment key={profile.webCalendarProfileId}>
              {i > 0 && <Divider />}
              <CalendarProfileStackItem
                onEditProfileClick={onEditProfileClick}
                profile={profile}
              />
            </React.Fragment>
          ))}
        </>
      ) : null}
    </Stack>
  )
}
